import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { getUsersAction, deleteUserAction } from '@store/actions/user-management';
import { getAllUsers, getStatus, getAllUsersQueryParams } from '@store/reducers/user-management/selectors';
import {
  getPermittedPermissions,
  getPermissionCheckStatus,
  getIsPermissionChecked,
} from '@store/reducers/check-permission/selectors';
import { setIsPermissionCheckedAction, checkPermissionAction } from '@store/actions/check-permission';
import Main from './Main';

const mapStateToProps = state => ({
  allUsers: getAllUsers(state),
  status: getStatus(state),
  queryParams: getAllUsersQueryParams(state),
  permittedPermissions: getPermittedPermissions(state),
  isPermissionChecked: getIsPermissionChecked(state),
  checkPermissionStatus: getPermissionCheckStatus(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getUsersAction,
      deleteUserAction,
      setIsPermissionCheckedAction,
      checkPermissionAction,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
